/* ★ LANGKAH BERGARIS — senarai "Cara betulkan" sebagai langkah bernombor bersambung garis menegak
 * (lakaran diluluskan user 2026-09-24). Dipakai PopupRunDitahan bila `gayaLangkah` dihidupkan.
 *
 * ⚠️ KEMBAR rupa: popup halaman Flow (flow-common.js `_flowPopupHalang`) melukis langkah yang sama dengan DOM
 *    biasa (Trusted Types). Ubah rupa di sini = ubah di sana.
 *
 * langkah: [string | { teks, tag?: string[] }] — `tag` = cip kecil di bawah teks (cth senarai model).
 */
import React from 'react';

const GARIS = 'var(--s-line-2, rgba(0,0,0,.14))';

export default function LangkahBergaris({ langkah }) {
    const senarai = (Array.isArray(langkah) ? langkah : [])
        .map((l) => (typeof l === 'string' ? { teks: l } : l))
        .filter((l) => l && l.teks);
    return (
        <div>
            {senarai.map((l, i) => {
                const akhir = i === senarai.length - 1;
                const tag = Array.isArray(l.tag) ? l.tag.filter(Boolean) : [];
                return (
                    <div key={i} style={{ display: 'flex', gap: 12 }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 'none' }}>
                            <span style={{
                                width: 24, height: 24, borderRadius: 999, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: 12, fontWeight: 600, border: '1px solid var(--s-ink-3, #8a8a8a)',
                                background: 'var(--s-panel, #ffffff)', color: 'var(--s-ink, #262626)',
                            }}>{i + 1}</span>
                            {!akhir && <span style={{ flex: 1, width: 1, background: GARIS, margin: '4px 0' }} />}
                        </div>
                        <div style={{ paddingTop: 3, paddingBottom: akhir ? 0 : 14, minWidth: 0 }}>
                            <div style={{ fontSize: 13, fontWeight: 500, lineHeight: 1.45, color: 'var(--s-ink, #262626)' }}>{l.teks}</div>
                            {tag.length > 0 && (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
                                    {tag.map((t) => (
                                        <span key={t} style={{
                                            fontSize: 12, padding: '3px 10px', borderRadius: 999,
                                            border: `1px solid ${GARIS}`, background: 'var(--s-panel, #ffffff)', color: 'var(--s-ink, #262626)',
                                        }}>{t}</span>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
